import { createItems, Game, GameCategory } from '@repo-level/core-front';
import { CMSCountryParams, CMSGroupParams, CMSScheduler } from 'api/cms/base';
import { Categories } from 'modules/landingPage/components/helpers';

export enum GameRecommendationCategories {
  Favorites = 'favorites',
  Recent = 'recent',
}

export interface UpdatedGameCategory
  extends GameCategory,
    CMSScheduler,
    CMSGroupParams,
    CMSCountryParams {
  description: string | undefined;
  icon?: string;
  order: number;
  href: string;
  showSeparately: boolean;
}

export const providersInvertLogo = [
  'mascot',
  'spribe',
  'baddingo',
  'jaderabbit',
  'petersons',
  'relax',
];

export enum GameErrorType {
  NotFound,
  NotAvailCurrency,
  NotAuthenticated,
}

export const getGamesPlugs = (
  gamesList: Game[],
  gamesPerRow: number,
  slidesPerView: number,
  options?: {
    onlyFirstRow?: boolean;
  }
) => {
  if (options?.onlyFirstRow && gamesList.length >= slidesPerView) {
    return [];
  }

  const gridArea = gamesPerRow * Math.ceil(slidesPerView);

  let numberOfGamesPlug =
    gamesList.length <= gridArea
      ? gridArea - gamesList.length
      : gamesList.length % gridArea;

  if (gamesList.length > gridArea) {
    if (numberOfGamesPlug === gamesList.length) {
      return [];
    }

    if (numberOfGamesPlug >= gamesPerRow) {
      numberOfGamesPlug = numberOfGamesPlug % gamesPerRow;
    } else if (numberOfGamesPlug > 0) {
      numberOfGamesPlug = gamesPerRow - numberOfGamesPlug;
    }
  }

  const gamesPlug = createItems({}, numberOfGamesPlug);

  return gamesPlug as Game[];
};

export const filterGames = (games: Game[], category: string) => {
  return games
    .filter(({ listCollections }) => listCollections.includes(category))
    .sort((a, b) => a.collections[category] - b.collections[category]);
};

export const getLocalizedCategoryId = (
  gameCategories: UpdatedGameCategory[],
  category: string
) =>
  gameCategories.find(({ id }) => new RegExp(`^${category}`).test(id))?.id ||
  category;
